export const debounce = function (fn, ms = 0) {
  let timeoutId;
  const pending = [];
  return function (...args) {
    const ctx = this;
    return new Promise((res, rej) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const currentPending = [...pending];
        pending.length = 0;
        try {
          Promise.resolve(fn.apply(ctx, args)).then(
            data => {
              currentPending.forEach(({ resolve }) => resolve(data));
            },
            error => {
              currentPending.forEach(({ reject }) => reject(error));
            },
          );
        } catch (error) {
          currentPending.forEach(({ reject }) => reject(error));
        }
      }, ms);
      pending.push({ resolve: res, reject: rej });
    });
  };
};
